
import { FormControl, FormHelperText, MenuItem, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
import { isNullEmpty } from "../../../utils/validation";
import { getOrderFormOrderQuantityOutput } from "../../../http/api/MasterAPI";

const OrderFormOrderQuantityOutputSelect = ({ value, error, onChangeValue }) => {
  const [listOrderFormOrderQuantityOutputSelect, setListOrderFormOrderQuantityOutputSelect] = useState([]);
 
  async function getOrderFormOrderQuantityOutputSelect() {
    try {
      const response = await getOrderFormOrderQuantityOutput();
      const varList = response.masterVarInfo;
      const result = varList
        .map((element) => ({
          orderFormOrderQuantityOutputCd: element.varCd,
          orderFormOrderQuantityOutputName: element.varValue1,
        }))
        .filter(
          (x) => x.orderFormOrderQuantityOutputName && x.orderFormOrderQuantityOutputName.trim() !== ""
        );
      setListOrderFormOrderQuantityOutputSelect(result);
    } catch (error) {
      console.error("Failed to fetch shop info:", error);
    }
  }

  useEffect(() => {
    getOrderFormOrderQuantityOutputSelect();
  }, []);

  


  return (
    <FormControl>
      <Select
        value={value}
        onChange={(e) => onChangeValue(e.target.value)}
        sx={{ width: 200 }}
        error={!isNullEmpty(error)}
        //onFocus={ () => validate.handleTouch("orderFormOrderQuantityOutputCd")}
      >
        {listOrderFormOrderQuantityOutputSelect.map((item) => (
          <MenuItem
            key={"orderFormOrderQuantityOutput" + item.orderFormOrderQuantityOutputCd}
            value={item.orderFormOrderQuantityOutputCd}
          >
            {item.orderFormOrderQuantityOutputName}
          </MenuItem>
        ))}
      </Select>
      {!isNullEmpty(error) && (
        <FormHelperText sx={{color:"#d32f2f",marginLeft: 0 }}>{error}</FormHelperText>
      )}
    </FormControl>
    
  );
};

export default OrderFormOrderQuantityOutputSelect;
